import { cx } from "shared/utils/classnames";

export const CONTROL_TOOLTIP_CLASS =
  "max-w-[320px] rounded-lg border bg-alpha-800 p-3 text-sm text-white z-50";

export const modePillClass = (selected: boolean) =>
  cx(
    "rounded-full px-3 py-1 text-sm font-medium whitespace-nowrap transition-colors",
    selected
      ? "bg-primary-20 text-primary-500"
      : "text-content-600 hover:text-content-1000"
  );
